import React from "react";
// import styled from "@emotion/styled";
import { Box } from "@atoms";

// == Types ================================================================

interface IProps {}

// == Constants ============================================================

BulkShopFlag.defaultProps = {};

// == Component ============================================================

export default function BulkShopFlag({ ...rest }: IProps) {
  return (
    <Box {...rest}>
      <svg
        id="Layer_1"
        version="1.1"
        viewBox="0 0 26 50"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <polygon fill="#5E28FF" points="26,50 13,38 0,50 0,0 26,0 " />
        <g>
          <path d="M20,10.6h-5v17.1h-4.3V10.6h-5V6.8H20V10.6z" fill="#FFFFFF" />
        </g>
      </svg>
    </Box>
  );
}

// == Styles ===============================================================
